//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

const consola = require('consola'); consola.level = process.env.CONSOLA_LEVEL;
import { mapGetters, mapMutations, mapActions } from 'vuex'
import svgSymbol from '~/components/svg-symbol'
import Domel from '~/components/domel.vue'
// import wysiwyg from "~/lib/vue-wysiwyg"
// import "vue-wysiwyg/dist/vueWysiwyg.css"

import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

// WARNING: do NOT import it here because it will crash SSR.
// import { quillEditor } from 'vue-quill-editor'
// import { quillEditor } from 'vue-quill-editor/dist/ssr'


// let _editor = null;

let directives;
if (process.browser)
{
	const { quillEditor } = require('vue-quill-editor/dist/ssr')
	directives = process.browser ? { 'quill': quillEditor } : { };
}
else
{
	directives = {}
}

// const directives = process.browser ? { 'quill': quillEditor } : { };

const editorOption = Object.freeze( {
			theme: 'bubble',
			placeholder: "<type content here>",
			modules: {
				toolbar: [
				['bold', 'italic', 'underline', 'strike'],
				[{ 'list': 'ordered'}, { 'list': 'bullet' }],
				[{ 'header': [1, 2, 3, 4, 5, 6, false] }],
				// [{ 'color': [] }, { 'background': [] }],
				// [{ 'font': [] }],
				// [{ 'align': [] }],
				// ['link', 'image'],
				['link'],
				['clean']
				]
			}
		}
		);

export default {
	// name: 'rest-rich-text',

	directives,

	components:
	{
		Domel,
		// EditorContent,
		// EditorMenuBar,
		svgSymbol,
		// 'wysiwyg': wysiwyg.component,
		// 'quill-editor': quillEditor
	},

	props:
	{
		// maxlength:
		// {
		// 	type: Number,
		// 	default: 0
		// },

		editable:
		{
			type: Boolean,
			default: false
		},

		tag:
		{
			type: String,
			default: 'span'
		},

		url:
		{
			type: String,
			default: ''
		},

		field:
		{
			type: String,
			default: ''
		},

		object:
		{
			type: Object,
			required: true,
		},

		columnField:
		{
			type: String,
			default: '',
		},

		html:
		{
			type: String,
			default: null,
		},

		// saveHtml:
		// {
		// 	type: Boolean,
		// 	default: false
		// },

		// the (locale-specific) object "id", not the parent id
		modelId:
		{
			type: Number,
			default: -1,
		}
	},

	data()
	{
		return {
			hasFocus: false,
			is_dirty: false,
			postData: Object.freeze({}),
			isEditorReady: false,
			editor: null,
			content: null,
			selectedColumns: 1,
			changedContent: null,
			// editorOption: {},
			editorOption,
		}
	},

	computed:
	{
		...mapGetters(['isEditingPage']),
		isDirty()	{	return this.is_dirty	},
		isEditable() { return this.isEditingPage || this.editable; },
		isSlotEmpty() {	return !this.$slots.default || !this.$slots.default.innerText },
		emptyStyle()
		{
			if (this.isEditable && this.field && this.isSlotEmpty)
				return { '--placeholder-text': `"<${this.field}>"` }
			return {}
		},

		showColumns()
		{
			return !!this.columnField;
		}
	},

	watch:
	{

		html(newVal)
		{
			// consola.debug('rest-rich-text: html newVal=', newVal)
			this.content = newVal;
		},

		content(newVal)
		{
			// consola.debug('rest-rich-text on content', newVal)
			const self = this;
			this.changedContent = newVal;
			// this.object[this.field] = newVal;
			// NOTE: move the $emit("input") at the onBlur handlers
			//		 because on @input they re-set the content
			//		 which causes the editor to lose focus
			//		 forcing the user to click again to enter another letter

			// consola.debug('$emit "input"')
			// this.$emit('input', newVal);
			// consola.debug('$eventBus.$emit "modify:model"', newVal)
			// setTimeout(
			// 	() =>
			// 	{
			// 		// consola.debug('$emit "input"', self.changedContent)
			// 		// self.$emit('input', self.changedContent);
			// 	}, 0)
			// self.$eventBus.$emit('modify:model', { obj: this.object,  field: this.field });
		},

		isEditingPage(newVal)
		{
			this.unregisterEvents();
			if (newVal)
			{
				this.hasFocus = true;
				this.registerEvents()
			}
			else
			{
				this.hasFocus = false;
			}
		},

		selectedColumns(newVal)
		{
			consola.debug('selectedColumns: ', newVal)
			if (this.columnField)
			{
				this.object[this.columnField] = newVal;
				// this.$emit('input', this.changedContent);
				this.$eventBus.$emit('modify:model', { obj: this.object,  field: this.columnField });
			}
		}
	},

	created ()
	{
		// consola.debug('rest-rich-text: ', this.html)
		this.content = this.html;
		// this.content = this.doubleBr( this.html );
	},

	beforeMount()
	{
		if (this.tag == 'p' )
		{
			console.error('<rest-rich-text> with tag="p" will cause errors on production')
		}
	},

	mounted()
	{
		this.onClick();
		// consola.debug('content: ', this.content);
		this.$nextTick( () =>
		{
			this.registerEvents()
		} )
	},

	beforeDestroy()
	{
		if (this.editor)
		{
			this.editor.destroy()
			this.editor = null;
		}
		this.unregisterEvents()
	},

	methods:
	{
		registerEvents()
		{
			if (!this.isEditingPage)	return;

			// consola.debug('registerEvents')
			if (!this.$refs.editor || !this.$refs.editor.firstElementChild)
			{
				consola.debug('this.$refs.editor: null')
				return;
			}
			this.$refs.editor.firstElementChild.addEventListener('focus', this.onFocus)
			this.$refs.editor.firstElementChild.addEventListener('blur', this.onBlur)
		},

		unregisterEvents()
		{
			if (!this.isEditingPage)	return;

			// consola.debug('unregisterEvents')
			if (!this.$refs.editor || !this.$refs.editor.firstElementChild)
			{
				consola.debug('this.$refs.editor: null')
				return;
			}
			this.$refs.editor.firstElementChild.removeEventListener('focus', this.onFocus)
			this.$refs.editor.firstElementChild.addEventListener('blur', this.onBlur)
		},

		doubleBr(str)
		{
			return str.replace(/<br>/gi, '<br><br>');
		},

		singleBr(str)
		{
			return str.replace(/<br><br>/gi, '<br>');
		},

		onClick()
		{
			if (this.isEditingPage)
			{
				// consola.debug('rest-rich-text onClick')
				this.hasFocus = true;
				window.__rich_editor = this;
			}
		},

		destroyEditor()
		{
			this.content = ( this.editor.getHTML() );
			// this.content = this.doubleBr( this.editor.getHTML() );
			this.isEditorReady = false;
			this.editor.destroy()
			this.editor = null;
			this.validate()
		},

		onInput(event)
		{
			// consola.debug('onInput: ', event)
			this.is_dirty = true;
			// if ( this.maxlength )
			// {
			// 	event.target.innerText = event.target.innerText.substring(0, this.maxlength)
			// }
			// if ( this.richtext == false )
			// {
			// 	// remove formating
			// 	event.target.innerHTML = event.target.innerText;
			// }

			// this.asyncCommit()
		},

		onFocus()
		{
			// consola.debug('rest-rich-text onFocus');
			this.hasFocus = true;
			// if (this.isEditingPage)
			// 	window.__rich_editor = this;
		},

		onBlur()
		{
			// consola.debug('rest-rich-text onBlur');
			this.hasFocus = false;

			// window.__rich_editor = null;

			// debugger;

			if ( this.changedContent!==null )
			{
				// setTimeout
				// consola.debug('$emit "input"', this.changedContent)
				// NOTE: see "watch: content" note for explanation why this is here
				this.$emit('input', this.changedContent);
				this.$eventBus.$emit('modify:model', { obj: this.object,  field: this.field });
				this.changedContent = null;
			}
			else
			{
				consola.debug('rich-text no changed content');
			}

			// if (this.is_dirty)
			// {
			// 	this.removeStyling();
			// 	this.asyncCommit();
			// }
		},

		removeStyling()
		{
			// debugger;
			function trek(node)
			{
				node.removeAttribute('style');
				for (let child of node.children)
					trek(child);
			}

			let parser = new DOMParser();
			let doc = parser.parseFromString(this.content, "text/html");
			if (doc)
			{
				let node = doc.body;
				trek(node);
				this.content = node.outerHTML;
			}

			// consola.debug(this.content);
		},

		validate()
		{
			// consola.debug('validate')
			this.is_dirty = true;
			// if ( this.maxlength )
			// {
			// 	event.target.innerText = event.target.innerText.substring(0, this.maxlength)
			// }
			this.asyncCommit()
		},

		addUpdateData(obj)
		{
			let data = {...this.postData, ...obj};
			this.postData = Object.freeze(data);
		},

		calcUpdateData()
		{
			let obj = {};
			// consola.debug('this.content: ', this.content)
			// debugger;
			// if (this.editor)
			// {
			// 	this.content = this.editor.getHTML()
			// 	consola.debug('calcUpdateData content: ', this.content)
			// }
			if (this.field.length > 0)
				obj[this.field] = this.content;

			let data = {...this.postData, ...obj};
			this.postData = Object.freeze(data);

			return this.postData;
		},


		sendDataToAncestor()
		{
			let parent = this.$parent
			// let id = -1
			while ( parent )
			{
				// consola.debug('_componentTag: ', parent.$options._componentTag)
				if (parent.$options._componentTag == 'nuxt')
					break;
				if (parent.$options._componentTag == 'rest-model')
				{
					parent.addUpdateData( { ...this.postData } )
					break
				}

				if (parent == parent.$parent)
					break;

				parent = parent.$parent
			}
		},



		asyncCommit()
		{
			consola.debug('rest-rich-text asyncCommit');
			if (this.is_dirty)
			{
				if (this.field.length > 0)
				{
					this.calcUpdateData()
					// debugger

					let emitEvent = false

					if (this.modelId > -1)
					{
						this.addUpdateData( { id: this.modelId } )

						if (this.url.length > 0)
						{
							// return this.$axios.put(this.url, this.postData)
							return this.$apiPut(this.url, this.postData)
											.then((param)=> { this.is_dirty = false; return param; })
											.catch( (error) =>
											{
												console.error(error);
											})
						}
						else
						{
							emitEvent = true
							// console.warn('editable-text has NO REST url...')
						}
					}
					else
					{
						emitEvent = true
						// console.warn('editable-text has NO model ID...')
					}

					if (emitEvent)
					{
						// NOTE: emiting events on an event-bus
						// causes *ALL* listeners to respond, regardless
						// of their position in the hierarchy.
						// best avoid that approach

						// consola.debug('emiting event...')
						// let data = { ...this.postData }
						// this.$eventBus.$emit('rest:model', data)
						// this.is_dirty = false

						this.sendDataToAncestor()
					}

				}
				else
					console.warn('rest-rich-text has NO field...')
			}
			else
			{
				console.warn('rest-rich-text is NOT dirty...')
			}

			return Promise.resolve(null)

			// if (this.is_dirty == false || this.url.length == 0 || this.field.length == 0)
			// {
			// 	return Promise.resolve(null)
			// }
			// else
			// {
			// 	let obj = {};
			// 	obj[this.field] = this.$refs.innerText;
			// 	this.is_dirty = false;
			// 	return this.$axios.post(this.url, obj)
			// }
		},

		async commit()
		{
			consola.debug('saving...');
			return await this.asyncCommit()
		},
	},

}
